import React from 'react'
import Img from '../../../public/images/apps/7.png'
import Img2 from '../../../public/images/apps/8.jpg'
import Img4 from '../../../public/images/apps/11.png'
import Img5 from '../../../public/images/apps/17.svg'
import Img6 from '../../../public/images/apps/18.png'
import Img7 from '../../../public/images/apps/19.png'
import Img8 from '../../../public/images/apps/15.png'
import Img9 from '../../../public/images/apps/16.png'
import Img10 from '../../../public/images/apps/19.webp'
import Img12 from '../../../public/images/apps/21.webp'
import Img13 from '../../../public/images/apps/22.webp'
import Card from '@mui/material/Card'
import Image from 'next/image'
import { Icon } from '@iconify/react';

function index() {
  const APPLICATIONS = [
    {
      id: 1,
      title: 'Telegram',
      img: Img5,
      time: '12:45 PM',
      size: '43s'
    },
    {
      id: 25,
      title: 'Safari',
      img: Img10,
      time: '10:18 PM',
      size: '23s'
    },
    {
      id: 26,
      title: 'Safari',
      img: Img10,
      time: '10:10 PM',
      size: '52s'
    },
    {
      id: 27,
      title: 'Music',
      img: Img12,
      time: '09:10 PM',
      size: '33s'
    },
    {
      id: 2,
      title: 'TikTok',
      img: Img2,
      time: '12:35 PM',
      size: '10s'
    },
    {
      id: 3,
      title: 'TikTok',
      img: Img2,
      time: '12:35 PM',
      size: '15s'
    },
    {
      id: 29,
      img: Img13,
      title: 'Shadowrocket',
      time: '12:20 PM',
      size: '12m 3s'
    },
    {
      id: 4,
      title: 'TikTok',
      img: Img2,
      time: '12:34 PM',
      size: '59s'
    },
    {
      id: 5,
      title: 'Twitter',
      img: Img4,
      time: '12:34 PM',
      size: '13s'
    },
    {
      id: 6,
      title: 'Telegram',
      img: Img5,
      time: '12:22 PM',
      size: '43s'
    },
    {
      id: 7,
      title: 'Pinterest',
      img: Img6,
      time: '12:10 PM',
      size: '2m 3s'
    },
    {
      id: 8,
      title: 'Pinterest',
      img: Img6,
      time: '12:01 PM',
      size: '6m 3s'
    },
    {
      id: 9,
      title: 'Gmail',
      img: Img7,
      time: '11:13 PM',
      size: '30s'
    },
    {
      id: 10,
      title: 'TikTok',
      img: Img2,
      time: '11:10 PM',
      size: '54s'
    },
    {
      id: 11,
      title: 'Twitter',
      img: Img4,
      time: '10:42 PM',
      size: '14s'
    },
    {
      id: 12,
      title: 'Telegram',
      img: Img5,
      time: '9:19 PM',
      size: '8m 6s'
    },
    {
      id: 13,
      title: 'Pinterest',
      img: Img6,
      time: '9:01 PM',
      size: '6m 39s'
    },
    {
      id: 14,
      title: 'Gmail',
      img: Img7,
      time: '8:13 PM',
      size: '30s'
    },
    {
      id: 15,
      title: 'Pinterest',
      img: Img6,
      time: '11:55 PM',
      size: '2m 43s'
    },
    {
      id: 16,
      title: 'Pinterest',
      img: Img6,
      time: '11:40 PM',
      size: '2m 3s'
    },
    {
      id: 17,
      title: 'Pinterest',
      img: Img6,
      time: '11:30 PM',
      size: '1m 3s'
    },
    {
      id: 18,
      title: 'Pinterest',
      img: Img6,
      time: '11:22 PM',
      size: '33s'
    },
    {
      id: 19,
      title: 'Pinterest',
      img: Img6,
      time: '11:18 PM',
      size: '1m 2s'
    },
    {
      id: 20,
      title: 'Chrome Browser',
      img: Img7,
      time: '11:01 PM',
      size: '5m 3s'
    },
    {
      id: 21,
      title: 'Chrome Browser',
      img: Img7,
      time: '10:30 PM',
      size: '2m 3s'
    },
    {
      id: 22,
      title: 'Facebook',
      img: Img8,
      time: '12:10 PM',
      size: '43s'
    },
    {
      id: 23,
      title: 'Chrome Browser',
      img: Img9,
      time: '12:13 PM',
      size: '2m 32s'
    },
    {
      id: 24,
      title: 'Chrome Browser',
      img: Img9,
      time: '10:20 PM',
      size: '2m 3s'
    }
  ];

  return (
    <Card >
      <div class='bg-[#f5f6fa] p-6'>
        <div className='md:w-2/3 sm:w-11/12 mx-auto  bg-white rounded-lg'>
          {
            APPLICATIONS.map(app => {
              return (
                <div key={app.id} className='flex h-[70px] items-center justify-between w-11/12 mx-auto'>
                  <div className='flex'>
                    <div>
                      <Image src={app.img} alt='img' className='w-[35px] h-[35px] rounded-xl' />
                    </div>
                    <div className='ml-4'>
                      <h2 className='font-semibold text-opacity-50 text-black'>{app.title}</h2>
                      <p className='text-[13px] text-opacity-60 text-black'>{app.time}</p>
                    </div>
                  </div>
                  <div className='grid justify-items-end'>
                    <h2 className='text-[0.875rem] font-medium text-black text-opacity-60'>{app.size}</h2>
                    <Icon icon="mdi:ellipsis-horizontal" />
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </Card>

  )
}

export default index
